// Converts a date from the YYYY-MM-DD format to DD-MM-YYYY
export const formatDate = (date) => {
  return date.split("-").reverse().join("-");
};

// Converts a date from DAY, DD Month Year time timezone (eg Tue, 02 Nov 2021 00:00:00 GMT) to DD-MM-YYYY
export const formatDateStr = (dateStr) => {
  const date = new Date(dateStr);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();
  return `${day}-${month}-${year}`;
};
